<template>
    <div class="card-wrap" :class="{'popupBg':isPopup}">
        <div class="card-header" :class="{'isFixed':isFixed}" v-if="title">
            <div class="card-header-info" :style="{backgroundImage:'url('+bg+')'}">
                <img :src="icon" class="card-header-icon"/>
                <div class="card-header-text" v-if="title2">{{title}}<span class="award">{{title2}}</span>{{title3}}</div>
                <div class="card-header-text" v-else>{{title}}</div>
            </div>
        </div>
        <div class="card-content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CardHegu',
    props:{
        title: {
            type: String,
            default: '',
        },
        title2: {
            type: String,
            default: '',
        },
        title3: {
            type: String,
            default: '',
        },
        position: {
            type: String,
            default: 'left',
        },
        isPopup:{
            type: Boolean,
            default: false
        },
        isFixed:{
            type: Boolean,
            default: false 
        }
    },
    computed:{
            bg(){
                return  '/theme/default/img/common/' + this.config.app.project + '/card-title-bg.png'
            }, 
            icon(){
                return  '/theme/default/img/common/' + this.config.app.project + '/card-title-icon.png'
            }, 
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.card-wrap{
    position:relative;
    width: 100%;
    height: 100%;
    background: rgba(1, 88, 120, 0.3);
	border-radius: 2rem;
	border: solid 0.1rem rgba(48, 136, 122, 0.3);
    overflow: hidden;
    display:flex;
    flex-direction: column;
    align-items: center;
    .card-header{
        flex: 0 0 auto;
        width: 100%;
        height: 3.6rem;
        background: linear-gradient(90deg, rgba(21, 88, 65, 0.5), rgba(12, 141, 68, 0.5), rgba(1, 88, 120, 0.5));
        >div{
            width:100%;
            height:100%;
            background-position: left bottom;
            background-repeat: no-repeat;
            background-size: 24.4rem auto;
            padding-left:1rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .card-header-icon{
                height: 2.7rem;
                margin-right: 0.3rem;
            }
            .card-header-text{
                font-size: 1.6rem;
                font-family: "PingFangSC-Heavy";
                font-weight: 800;
                color: #7DFFFF;
                .award{
                    font-style: italic;
                }
            }
        }
    }
    .isFixed{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .card-content{
        width:100%;
        height:100%;
    }
}
.popupBg{
    background:rgba(48, 136, 122,0.3);
}
</style>